const TypingDelayTimerType = 'delay';
const TypingAnimationTimerType = 'anim';

export {
    TypingAnimationTimerType,
    TypingDelayTimerType
}